import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '../assets/unknow.png'


const _hoisted_1 = {
  key: 0,
  class: "cm-align-center gap-x-3"
}
const _hoisted_2 = ["alt"]
const _hoisted_3 = { key: 1 }

import { PropType, reactive, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { Level, LevelValues, trRiskLevel } from '../types/ransomware-incident'


export default /*#__PURE__*/_defineComponent({
  __name: 'LevelType',
  props: {
  type: {
    type: Number as PropType<LevelValues>,
    required: true,
    default: 1
  }
},
  setup(__props) {

const props = __props

const { t, locale } = useI18n()

const levelLabel = computed(() => {
  void locale.value
  return trRiskLevel(t, props.type)
})

const cardType = reactive<{[P in LevelValues]: {color:string}}>({
  4: {
    color: '#e54545', // dm-keep
  },
  3: {
    color: '#fb8f10', // dm-keep
  },
  2: { color: '#ffc600',}, // dm-keep
  1: { color: '#999999',}, // dm-keep
})

return (_ctx: any,_cache: any) => {
  return (levelLabel.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(Level).Default === __props.type)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _imports_0,
              class: "",
              style: {"width":"18px","height":"18px"},
              alt: levelLabel.value
            }, null, 8, _hoisted_2))
          : (_openBlock(), _createElementBlock("i", {
              key: 1,
              class: "iconfont cm-icon-warning",
              style: _normalizeStyle({color: cardType[__props.type]?.color})
            }, null, 4)),
        _createElementVNode("span", {
          style: _normalizeStyle({color: cardType[__props.type]?.color})
        }, _toDisplayString(levelLabel.value), 5)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, "--"))
}
}

})